import React from "react";
import Box from "@mui/material/Box";

import Grid from "@mui/material/Grid";
import MollierPlot from "./MollierPlot";
import Button from "@mui/material/Button";
import AddBoxIcon from "@mui/icons-material/AddBox";

import { useState, useEffect, useContext, useRef } from "react";

import AirProcess from "./airProcesses/AirProcess";
import ControlPanelExcel from "./ControlPanelExcel";
import ProcessChanges from "./ProcessChanges";
import { useLocation } from "react-router-dom";
import { weatherCtx } from "../../utils/hooks/mollierWeatherContext";
import { Provider } from "../../utils/hooks/mollierWeatherContext";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useTranslation } from "react-i18next";

import { dzavra } from "./calculations";
import {
  setProcessPoint,
  getArrayData,
  updateOutdoorPoint,
  updateIndoorPoint,
  addNewSummerProcessPoint,
  updateDLLEhaPoint,
  updateDLLSupPoint,
  setInitialState,
  addOrUpdateCoolingPoint,
  addOrUpdateHeatingPoint,
  addOrUpdateMixingPoint,
  updateCoolerSupPoint,
  updateCoolerEhaPoint,
} from "../../actions/summerPointsActions";
import {
  updateIndoorPointWinter,
  updateOutdoorPointWinter,
  addNewWinterProcessPoint,
  updateDLLEhaPointWinter,
  updateDLLSupPointWinter,
  setInitialStateWinter,
  addOrUpdateCoolingPointWinter,
  addOrUpdateHeatingPointWinter,
  addOrUpdateMixingPointWinter,
  updateHeaterSupPoint,
  updateHeaterEhaPoint,
} from "../../actions/winterPointsActions";

import { getTechCardDataForMollier } from "../../utils/services/projectService";
import AHU from "./AHUSVGFLAT.svg";
import RotaryImg from "./images/MollierRotary.svg";
import EnthalpyImg from "./images/MollierEnthalpy.svg";
import CondensingImg from "./images/MollierCondensing.svg";
import RotaryCoils from "./images/RotaryCoils.svg";
import EnthalpyCoils from "./images/EnthalpyCoils.svg";
import CondensingCoils from "./images/CondensingCoils.svg";

import { useMediaQuery } from "@mui/material";

function Molijer() {
  //const { summerWeather } = useContext(weatherCtx);
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const [DBMollier, setDBMollier] = useState(false);
  const { t } = useTranslation();

  const unitTypeMapping = {
    1: "Rotary",
    2: "Rotary",
    3: "Rotary",
    4: "Rotary",
    5: "Rotary",
    6: "Plate",
    7: "Plate",
    8: "Plate",
    9: "Plate",
    10: "Plate",
    11: "Enthalpy",
    12: "Enthalpy",
    13: "Enthalpy",
    14: "Enthalpy",
    15: "Enthalpy",
  };
  const [projectInfo, setProjectInfo] = useState({
    projectName: "",
    location: "",
  });
  const [chartConfig, setChartConfig] = useState({
    minTemp: -21,
    maxTemp: 40,
    minAbsoluteHumidity: 0,
    maxAbsoluteHumidity: 20,
    altitude: 0,
    airPressure: 101325,
    airflow: 10000,
    airflowUnit: 10,
    mixingRatio: 100,

    maximalHumidityInProcess: 100,
    coolerSurfaceTemperature: 10,
  });
  const [axisChange, setHandleAxisChange] = useState(false);
  //const { chartConfig, setChartConfig } = useContext(weatherCtx);

  const [summerWeather, setSummerWeather] = useState(true);
  // const [summerProcesses, setSummerProcesses] = useState([]);
  // const [winterProcesses, setWinterProcesses] = useState([]);
  const summerPoints = useSelector((state) => state.processPoint.summerPoints);
  const winterPoints = useSelector((state) => state.winterPoints.winterPoints);
  const points = useSelector(
    (state) => state.processPoint.summerPoints,
    shallowEqual
  );
  const prevPointsRef = useRef(points);
  const prevWinterPointsRef = useRef(winterPoints);
  const [summerProcesses, setSummerProcesses] = useState(summerPoints);
  const [winterProcesses, setWinterProcesses] = useState(winterPoints);
  const [recuperatorProcesses, setRecuperatorProcesses] = useState({
    summer_Sup_AirTempOut: 0,
    summer_Sup_HumidityOutAbsolute: 0,
    winter_Sup_AirTempOut: 0,
    winter_Sup_HumidityOutAbsolute: 0,
    summer_Exa_AirTempOut: 0,
    summer_Exa_HumidityOutAbsolute: 0,
    winter_Exa_AirTempOut: 0,
    winter_Exa_HumidityOutAbsolute: 0,
    cooler_Sup_AirTempOut: 0,
    cooler_Sup_HumidityOutAbsolute: 0,
    heater_Sup_AirTempOut: 0,
    heater_Sup_HumidityOutAbsolute: 0,
    cooler_Exa_AirTempOut: 0,
    cooler_Exa_HumidityOutAbsolute: 0,
    heater_Exa_AirTempOut: 0,
    heater_Exa_HumidityOutAbsolute: 0,
  });
  const dispatch = useDispatch();

  function handleAxisChange() {
    setHandleAxisChange(!axisChange);
  }
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const changedIndex = points.findIndex(
      (point, index) => !shallowEqual(point, prevPointsRef.current[index])
    );
    const lengthChanged =
      points.length < prevPointsRef.current.length ? true : false;

    if (points.length > 2 && changedIndex !== -1) {
      if (changedIndex === points.length - 1) return;
      else if (changedIndex === 1 && points[2].process !== 30) return;
      else {
        (lengthChanged ? points : points.slice(changedIndex + 1)).map(
          (item) => {
            switch (item.process) {
              case "indoor":
                dispatch(
                  updateIndoorPoint(
                    item.temperatureDryBulb,
                    0,
                    0,
                    item.relativeHumidity,

                    chartConfig.altitude,
                    item.airFlowHours
                  )
                );
                break;
              case 10:
                summerWeather
                  ? dispatch(
                      addOrUpdateHeatingPoint(
                        item.temperatureDryBulb,
                        chartConfig.altitude,
                        item.id
                      )
                    )
                  : dispatch(
                      addOrUpdateHeatingPointWinter(
                        item.temperatureDryBulb,
                        chartConfig.altitude,
                        item.id
                      )
                    );
                break;
              case 20:
                summerWeather
                  ? dispatch(
                      addOrUpdateCoolingPoint(
                        item.temperatureDryBulb,
                        null,
                        null,
                        null,
                        chartConfig.coolerSurfaceTemperature,
                        chartConfig.altitude,
                        chartConfig.maximalHumidityInProcess,
                        item.id
                      )
                    )
                  : dispatch(
                      addOrUpdateCoolingPointWinter(
                        item.temperatureDryBulb,
                        null,
                        null,
                        null,
                        chartConfig.coolerSurfaceTemperature,
                        chartConfig.altitude,
                        chartConfig.maximalHumidityInProcess,
                        item.id
                      )
                    );
                break;
              case 30:
                summerWeather
                  ? dispatch(
                      addOrUpdateMixingPoint(chartConfig.altitude, item.id)
                    )
                  : dispatch(
                      addOrUpdateMixingPointWinter(
                        chartConfig.altitude,
                        item.id
                      )
                    );
                break;
              //case 40:
            }
          }
        );
        //potreban update svih naredih tacaka????????????????????????????????????????
        //znaci prolazi kroz niz i radim dispath akcija u zavisnosti od procesa
      }
      console.log(
        "Point at index",
        changedIndex,
        "changed:",
        points[changedIndex]
      );
    }

    // Update the previous points to the current points for the next comparison
    prevPointsRef.current = points;
  }, [points]);

  useEffect(() => {
    const changedIndex = winterPoints.findIndex(
      (point, index) => !shallowEqual(point, prevWinterPointsRef.current[index])
    );
    const lengthChanged =
      points.length < prevPointsRef.current.length ? true : false;

    if (winterPoints.length > 2 && changedIndex !== -1) {
      console.log("index" + changedIndex + "duzina");
      console.log(changedIndex === winterPoints.length - 1);
      if (changedIndex === winterPoints.length - 1) return;
      else if (changedIndex === 1 && winterPoints[2].process !== 30) return;
      else {
        (lengthChanged
          ? winterPoints
          : winterPoints.slice(changedIndex + 1)
        ).map((item) => {
          console.log("Menjam" + JSON.stringify(item));
          switch (item.process) {
            case "indoor":
              console.log("Menjacu indoor");
              dispatch(
                updateIndoorPointWinter(
                  item.temperatureDryBulb,
                  0,
                  0,
                  item.relativeHumidity,

                  chartConfig.altitude,
                  item.airFlowHours
                )
              );
              break;
            case 10:
              console.log("Menjacu heating");
              summerWeather
                ? dispatch(
                    addOrUpdateHeatingPoint(
                      item.temperatureDryBulb,
                      chartConfig.altitude,
                      item.id
                    )
                  )
                : dispatch(
                    addOrUpdateHeatingPointWinter(
                      item.temperatureDryBulb,
                      chartConfig.altitude,
                      item.id
                    )
                  );
              break;
            case 20:
              console.log("Menjacu cooling" + item.id);
              console.log(item.id);
              summerWeather
                ? dispatch(
                    addOrUpdateCoolingPoint(
                      item.temperatureDryBulb,
                      null,
                      null,
                      null,
                      chartConfig.coolerSurfaceTemperature,
                      chartConfig.altitude,
                      chartConfig.maximalHumidityInProcess,
                      item.id
                    )
                  )
                : dispatch(
                    addOrUpdateCoolingPointWinter(
                      item.temperatureDryBulb,
                      null,
                      null,
                      null,
                      chartConfig.coolerSurfaceTemperature,
                      chartConfig.altitude,
                      chartConfig.maximalHumidityInProcess,
                      item.id
                    )
                  );
              break;
            case 30:
              summerWeather
                ? dispatch(
                    addOrUpdateMixingPoint(chartConfig.altitude, item.id)
                  )
                : dispatch(
                    addOrUpdateMixingPointWinter(chartConfig.altitude, item.id)
                  );
              break;
            //case 40:
          }
        });
        //potreban update svih naredih tacaka????????????????????????????????????????
        //znaci prolazi kroz niz i radim dispath akcija u zavisnosti od procesa
      }
      console.log(
        "Point at index",
        changedIndex,
        "changed:",
        winterPoints[changedIndex]
      );
    }

    // Update the previous points to the current points for the next comparison
    prevWinterPointsRef.current = winterPoints;
  }, [winterPoints]);

  useEffect(() => {
    points.map((item) => {
      switch (item.process) {
        case "outdoor":
          dispatch(
            updateOutdoorPoint(
              item.temperatureDryBulb,
              0,
              0,
              item.relativeHumidity,

              chartConfig.altitude,
              item.airFlowHours
            )
          );
          break;
        case "indoor":
          dispatch(
            updateIndoorPoint(
              item.temperatureDryBulb,
              0,
              0,
              item.relativeHumidity,

              chartConfig.altitude,
              item.airFlowHours
            )
          );
          break;
        case 10:
          dispatch(
            addOrUpdateHeatingPoint(
              item.temperatureDryBulb,
              chartConfig.altitude,
              item.id
            )
          );

          break;
        case 20:
          dispatch(
            addOrUpdateCoolingPoint(
              item.temperatureDryBulb,
              null,
              null,
              null,
              chartConfig.coolerSurfaceTemperature,
              chartConfig.altitude,
              chartConfig.maximalHumidityInProcess,
              item.id
            )
          );

          break;
        case 30:
          dispatch(addOrUpdateMixingPoint(chartConfig.altitude, item.id));

          break;
        //case 40:
      }
    });
    winterPoints.map((item) => {
      switch (item.process) {
        case "outdoor":
          dispatch(
            updateOutdoorPointWinter(
              item.temperatureDryBulb,
              0,
              0,
              item.relativeHumidity,

              chartConfig.altitude,
              item.airFlowHours
            )
          );
          break;
        case "indoor":
          dispatch(
            updateIndoorPointWinter(
              item.temperatureDryBulb,
              0,
              0,
              item.relativeHumidity,

              chartConfig.altitude,
              item.airFlowHours
            )
          );
          break;
        case 10:
          dispatch(
            addOrUpdateHeatingPointWinter(
              item.temperatureDryBulb,
              chartConfig.altitude,
              item.id
            )
          );

          break;
        case 20:
          dispatch(
            addOrUpdateCoolingPointWinter(
              item.temperatureDryBulb,
              null,
              null,
              null,
              chartConfig.coolerSurfaceTemperature,
              chartConfig.altitude,
              chartConfig.maximalHumidityInProcess,
              item.id
            )
          );

          break;
        case 30:
          dispatch(addOrUpdateMixingPointWinter(chartConfig.altitude, item.id));

          break;
        //case 40:
      }
    });
  }, [chartConfig.altitude]);

  function addProcess() {
    if (summerWeather === true) {
      dispatch(addNewSummerProcessPoint());
      // process.processNumber = "Process " + summerProcesses.length;
      // setSummerProcesses((prev) => [...prev, process]);
    } else {
      dispatch(addNewWinterProcessPoint());
      // process.processNumber = "Process " + winterProcesses.length;
      //setWinterProcesses((prev) => [...prev, process]);
    }
  }
  const handleConfigChange = (e) => {
    let { name, value } = e.target;

    setChartConfig((prev) => {
      return { ...prev, [name]: +value };
    });
  };

  useEffect(() => {
    if (location.state !== null) setDBMollier(true);

    setTimeout(() => {
      setChartConfig((prev) => {
        return { ...prev, minTemp: ++prev.minTemp };
      });
    }, 100);
    dispatch(setInitialState());
    dispatch(setInitialStateWinter());
    if (location.state !== null) {
      // dispatch(setInitialState());
      //dispatch(setInitialStateWinter());
      dispatch(
        updateOutdoorPoint(
          location.state.summerOutdoorTemperature,
          location.state.summerWetBulbTemperature,
          location.state.summerDewPointTemperature,
          location.state.summerOutdoorHumidity,
          location.state.elevation,
          location.state.flowSupply
        )
      );

      dispatch(
        updateIndoorPoint(
          location.state.summerIndoorTemperature,
          0,
          0,
          location.state.summerIndoorHumidity,
          location.state.elevation,
          location.state.flowReturn
        )
      );

      dispatch(
        updateOutdoorPointWinter(
          location.state.winterOutdoorTemperature,
          0,
          0,
          location.state.winterOutdoorHumidity,
          location.state.elevation,
          location.state.flowSupply
        )
      );

      dispatch(
        updateIndoorPointWinter(
          location.state.winterIndoorTemperature,
          0,
          0,
          location.state.winterIndoorHumidity,
          location.state.elevation,
          location.state.flowReturn
          //location.state.flowSupply
        )
      );
      getTechCardDataForMollier(
        location.state.projectItemId,
        location.state.revisionNumber
      )
        .then((res) => {
          setProjectInfo({
            projectName: res.data.data.projectName,
            location: res.data.data.location,
          });
          if (res.statusCode === 200) setRecuperatorProcesses(res.data.data);

          dispatch(
            updateDLLSupPoint(
              res.data.data.summer_Sup_AirTempOut,

              res.data.data.summer_Sup_HumidityOut,

              location.state.elevation,
              location.state.flowSupply
            )
          );
          dispatch(
            updateDLLEhaPoint(
              res.data.data.summer_Exa_AirTempOut,
              res.data.data.summer_Exa_HumidityOut,
              location.state.elevation,
              location.state.flowReturn
            )
          );
          if (
            location.state.coils == "both" ||
            location.state.coils == "cooler"
          )
            dispatch(
              updateCoolerSupPoint(
                location.state.summerSupplyTemperature,

                location.state.summerIndoorHumidity,

                location.state.elevation,
                location.state.flowSupply
              )
            );
          /*  if (
            location.state.coils == "both" ||
            location.state.coils == "cooler"
          )
            dispatch(
              updateCoolerEhaPoint(
                res.data.data.cooler_Exa_AirTempOut,
                res.data.data.cooler_Exa_HumidityOut,
                location.state.elevation,
                location.state.flowReturn
              )
            );*/

          dispatch(
            updateDLLSupPointWinter(
              res.data.data.winter_Sup_AirTempOut,
              res.data.data.winter_Sup_HumidityOut,
              location.state.elevation,
              location.state.flowSupply
            )
          );
          dispatch(
            updateDLLEhaPointWinter(
              res.data.data.winter_Exa_AirTempOut,
              res.data.data.winter_Exa_HumidityOut,
              location.state.elevation,
              location.state.flowReturn
            )
          );
          if (
            location.state.coils == "both" ||
            location.state.coils == "heater"
          )
            dispatch(
              updateHeaterSupPoint(
                location.state.winterSupplyTemperature,
                location.state.winterIndoorHumidity,
                location.state.elevation,
                location.state.flowReturn
              )
            );
          /*  if (
            location.state.coils == "both" ||
            location.state.coils == "heater"
          )
            dispatch(
              updateHeaterEhaPoint(
                res.data.data.heater_Exa_AirTempOut,
                res.data.data.heater_Sup_HumidityOut,
                location.state.elevation,
                location.state.flowReturn
              )
            );*/
        })
        .catch((err) => {
          console.log(err);
        });

      setChartConfig((prev) => {
        return {
          ...prev,
          altitude: location.state.elevation,
          airflow: location.state.flowSupply + location.state.flowReturn,
          mixingRatio: Math.round(
            (location.state.flowSupply /
              (location.state.flowSupply + location.state.flowReturn)) *
              100
          ),
        };
      });
    }

    // if (summerProcesses.length > 1 && winterProcesses.length > 1)
    setLoading(false);
  }, []);

  return loading ? (
    <div>Ucitavanje</div>
  ) : (
    <Provider
      value={{ summerWeather, setSummerWeather, chartConfig, setChartConfig }}
    >
      <Box>
        <Grid
          container
          spacing={2}
          alignItems="start"
          justifyContent={{ lg: "space-around" }}
          //paddingLeft="30px"
        >
          <Grid item xs={12} xl={5}>
            <MollierPlot
              chartConfig={chartConfig}
              axisChange={axisChange}
              handleConfigChange={handleConfigChange}
              handleAxisChange={handleAxisChange}
              recuperatorProcesses={recuperatorProcesses}
              DBMollier={DBMollier}
              positionName={location.state !== null ? location.state.name : ""}
              revisionNumber={
                location.state !== null ? location.state.revisionNumber : ""
              }
              projectInfo={projectInfo}
              isSmallScreen={isSmallScreen}
              unitType={
                location.state !== null
                  ? unitTypeMapping[location.state.sizeOfUnit]
                  : ""
              }
              coils={location.state?.coils}
            />
          </Grid>
          <Grid item xs={12} xl={4} m={2} mt={16}>
            <ControlPanelExcel
              handleConfigChange={handleConfigChange}
              handleAxisChange={handleAxisChange}
              altitude={chartConfig.altitude}
              airflow={chartConfig.airflow}
              indoorAirFlowUnit={10}
              maximalHumidityInProcess={chartConfig.maximalHumidityInProcess}
              addProcess={addProcess}
              coolerSurfaceTemperature={chartConfig.coolerSurfaceTemperature}
              DBMollier={DBMollier}
            />
            {!DBMollier &&
              (summerWeather
                ? summerPoints.length < 6
                : winterPoints.length < 6) && (
                <Button
                  size="large"
                  onClick={addProcess}
                  startIcon={
                    <AddBoxIcon
                      fontSize="large"
                      /*sx={{
                  fontSize: "32px",
                  marginLeft: "38px",
                  marginBottom: "16px",
                }}*/
                    />
                  }
                >
                  {t("mollier.addProcess")}
                </Button>
              )}
            {!DBMollier &&
              (summerWeather
                ? summerPoints.length > 2
                  ? summerPoints.slice(2).map((item) => {
                      return <AirProcess key={item.id} processDetails={item} />;
                    })
                  : null
                : winterPoints.length > 2
                ? winterPoints.slice(2).map((item) => {
                    return <AirProcess processDetails={item} />; //key={item.id}
                  })
                : null)}
            {DBMollier && (
              <Box
                width={{ xs: "200", lg: "600" }}
                height={{ xs: "100", lg: "250" }}
                margin={10}
              >
                <img
                  src={
                    unitTypeMapping[location.state.sizeOfUnit] === "Rotary"
                      ? summerPoints.length > 4 || winterPoints.length > 4
                        ? RotaryCoils
                        : RotaryImg
                      : unitTypeMapping[location.state.sizeOfUnit] ===
                        "Enthalpy"
                      ? summerPoints.length > 4 || winterPoints.length > 4
                        ? EnthalpyCoils
                        : EnthalpyImg
                      : summerPoints.length > 4 || winterPoints.length > 4
                      ? CondensingCoils
                      : CondensingImg
                  }
                  alt="test"
                  id="ahuScheme"
                />
              </Box>
            )}
          </Grid>

          <Grid item m={2} mt={6}>
            <Box sx={{ justifyContent: "start" }}>
              <ProcessChanges DBMollier={DBMollier} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Provider>
  );
}

export default Molijer;
